module.exports = __webpack_public_path__ + "img/bootstrap.64ab5c04.svg";